import styled from 'styled-components';

interface StyleProps {
  backgroundColor?: string;
  position?: 'top' | 'bottom';
  color?: string;
}

const Div = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px 16px;
  background-color: #ffffff;
  /* margin-bottom: 8px; */
`;

const Item = styled.div`
  display: flex;
  padding: 12px 0;
  justify-content: space-between;
  border-bottom: 1px solid #f3f5f7;
`;

const ItemLabel = styled.div`
  font-weight: 500;
  font-size: 13px;
  letter-spacing: -2%;
  color: #616161;
  white-space: nowrap;
`;

const Title = styled.div`
  color: #222222;
  font-size: 16px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 700;
`;

const Table = styled.div`
  display: flex;
  flex-direction: column;
  /* border-top: 1px solid #616161; */
`;

const ItemContent = styled.div<{ $idBold?: boolean }>`
  display: flex;
  flex-direction: row;
  gap: 4px;
  justify-content: flex-end;
  white-space: pre-wrap;

  font-weight: ${({ $idBold }) => ($idBold ? 700 : 500)};
  font-size: 14px;
  letter-spacing: -2%;
  color: #222;
`;

const CopyAddress = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  color: #008aff;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: -0.24px;
  white-space: nowrap;
`;

const TableRow = styled.div`
  display: flex;
  flex-direction: row;
  border-bottom: 1px solid #e1e2e4;
`;

const RowCategory = styled.div`
  width: 110px;
  padding: 10px 12px;
  background-color: #f7f8fc;
  font-size: 13px;
  font-weight: 500;
  color: #616161;
  display: flex;
  align-items: center;
`;

const RowContent = styled.div`
  width: 100%;
  padding: 10px 12px;
  font-size: 14px;
  font-weight: 500;
  color: #222222;
  text-align: left;
`;

const BlueSmallText = styled.div`
  font-size: 13px;
  font-weight: 400;
  color: #008aff;
`;

const LeftCell = styled.div`
  width: fit-content;
  font-size: 13px;
  font-weight: 500;
  color: #616161;
`;

const RightCell = styled.div`
  width: fit-content;
  font-size: 14px;
  font-weight: 500;
  color: #222222;
`;

const DivRow = styled.div<StyleProps>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: ${(props) => {
    if (props.position === 'top') return '16px 16px 10px 16px';
    if (props.position === 'bottom') return '10px 16px 16px 16px';
    return '10px 16px';
  }};
  background-color: ${(props) => props.backgroundColor || 'none'};
  border-top-left-radius: ${(props) =>
    props.position === 'top' ? '16px' : '0'};
  border-top-right-radius: ${(props) =>
    props.position === 'top' ? '16px' : '0'};
  border-bottom-left-radius: ${(props) =>
    props.position === 'bottom' ? '16px' : '0'};
  border-bottom-right-radius: ${(props) =>
    props.position === 'bottom' ? '16px' : '0'};
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  border-top: 1px solid #e5e8ea;
  border-bottom: 1px solid #e5e8ea;
  overflow: hidden;
`;

const InfoCell = styled.div<StyleProps>`
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: center;
  align-items: center;
  padding: ${(props) => {
    if (props.position === 'top') return '16px 16px 10px 16px';
    if (props.position === 'bottom') return '10px 16px 16px 16px';
    return '10px 16px';
  }};
  background-color: ${(props) => props.backgroundColor || 'none'};
  border-right: 1px solid #e5e8ea;
  border-bottom: 1px solid #e5e8ea;

  &:nth-child(2n) {
    border-right: none;
  }

  &:nth-last-child(-n + 2) {
    border-bottom: none;
  }
`;

const CellTitle = styled.div<StyleProps>`
  font-size: 12px;
  color: ${(props) => props.color || '#616161'};
  font-weight: 500;
  letter-spacing: -2%;
  text-align: center;
`;

const CellContent = styled.div<StyleProps>`
  font-size: 12px;
  color: ${(props) => props.color || '#222222'};
  font-weight: 500;
`;

const InterestButtonBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
`;
const InterestButton = styled.div`
  flex: 1;
  padding: 18px 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  font-weight: 500;
  color: #616161;
  cursor: pointer;
`;

const Divider = styled.div`
  width: 1px;
  height: 24px;
  background-color: rgba(112, 115, 124, 0.16);
`;

const GrayBox = styled.div`
  width: 100%;
  padding: 4px 16px;
  background-color: #f7f8fc;
  border-radius: 12px;
`;

const BlueBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  padding: 10px 12px;
  background-color: rgba(0, 138, 255, 0.05);
  border-radius: 8px;
`;

const Description = styled.div`
  display: flex;
  align-items: start;
  gap: 4px;
  color: #6b7684;
  font-size: 12px;
  font-weight: 500;
  word-break: keep-all;
`;

export const s = {
  Div,
  Item,
  ItemLabel,
  Title,
  Table,
  ItemContent,
  CopyAddress,
  TableRow,
  RowCategory,
  RowContent,
  BlueSmallText,
  LeftCell,
  RightCell,
  DivRow,
  Grid,
  InfoCell,
  CellTitle,
  CellContent,
  InterestButtonBox,
  InterestButton,
  Divider,
  GrayBox,
  BlueBox,
  Description,
};
